module.exports = __webpack_public_path__ + "img/offer-call-out.f8eb787a.svg";